<template>
  <button
    :class="classList"
    :disabled="disabled || loading"
    @click="handleClick"
  >
    <slot></slot>
    <div
      data-label
      :class="classListLabel"
    >
      {{ label }}
    </div>
    <Loader
      :visible="loading"
      :class="classListLoader"
    />
  </button>
</template>

<script>
import Loader from '@vuedir/components/Loader'

/**
 * ActionButton.vue
 *
 * <ActionButton label [loading] [disabled]></ActionButton>
 */
export default {
  components: {
    Loader,
  },

  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    inverted: {
      type: Boolean,
      default: false,
    },

    primary: {
      type: Boolean,
      default: false,
    },

    secondary: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['click'],

  data () {
    return {}
  },

  computed: {
    classList () {
      return [
        'btn',
        this.inverted ? 'btn--inverted' : '',
        this.disabled ? 'btn--disabled' : '',
        this.primary ? 'btn--primary' : '',
        this.secondary ? 'btn--secondary' : '',
      ]
    },

    classListLabel () {
      return [
        'transition-opacity',
        this.loading ? 'opacity-0' : '',
      ]
    },

    classListLoader () {
      return [
        'absolute top-50 left-50 -translate-center text-white transition-opacity',
        this.loading ? 'opacity-100' : 'opacity-0',
      ]
    },
  },

  methods: {
    handleClick () {
      this.$emit('click')
    },
  },
}
</script>
